module.exports = __webpack_public_path__ + "assets/qualtrics.0df48769.svg";